import {useActivityPath, useMoreToursPath, usePaymentPath, useTravelerPath} from 'providers/EnvironmentProvider'
import {useMemo} from 'react'
import {useShowMoreToursPage} from '../providers/EnvironmentProvider'
import {useOrderOfferCombinations} from './useOrderOfferCombinations'
import {useOrderQuestions} from './useOrderQuestions'

export const useStepperPaths = (): string[] => {
  const paymentPath = usePaymentPath()
  const activityPath = useActivityPath()
  const moreToursPath = useMoreToursPath()
  const travelerPath = useTravelerPath()

  const showMoreToursPage = useShowMoreToursPage()
  const orderQuestions = useOrderQuestions()
  const orderOfferCombinations = useOrderOfferCombinations()

  const stepperPaths = useMemo(
    () =>
      [
        travelerPath,
        orderQuestions.length > 0 ? activityPath : null,
        showMoreToursPage && orderOfferCombinations.length > 0 ? moreToursPath : null,
        paymentPath,
      ].filter((path) => path !== null),
    [travelerPath, activityPath, moreToursPath, paymentPath, orderQuestions, orderOfferCombinations, showMoreToursPage]
  )

  return stepperPaths as string[]
}
